import React from 'react'
import { NavLink } from 'react-router-dom'

import { RCTooltip } from 'components/RCTooltip'

import './index.scss'

export default function TabsList({ tabs }) {
  return (
    <div data-testid="test-tab-list" className="TabsList">
      {tabs.map(tab => {
        if (tab.isBlocked) {
          return (
            <RCTooltip key={tab.label} tooltipMessage={tab.blockedTabMessage} direction="bottom">
              <span className="TabItem-blocked-tab" data-testid={`tab-list-blocked-${tab.key ?? tab.label}`}>
                {tab.label}
              </span>
            </RCTooltip>
          )
        }
        return (
          <NavLink
            to={tab.path}
            onClick={() => {
              tab?.onClick?.()
            }}
            key={tab.label}
            className="tabItem"
            activeClassName="activeTabItem"
          >
            {tab.label}
          </NavLink>
        )
      })}
    </div>
  )
}
